module.exports = __webpack_public_path__ + "e25bad53b6889eb22b0ca33b7e4d53e7.png";